export default __webpack_public_path__ + "static/media/remixicon.symbol.5540ed53.svg";